import React from "react";

import "@styles/react-components/pagination.scss";

export default ({currentPage, pages, setCurrentPage, loading}) => {

  if(!pages){
    return null;
  }

  const handleClick = (page) => {
    if(setCurrentPage && !loading){
      setCurrentPage(page);
    }
  }

  return <div className={`pagination ${loading ? "loading" : ""}`}>
        {currentPage > 1 ? <a className="pagination__link pagination__item pagination__prev" onClick={() => handleClick(currentPage - 1)}>&lt;</a> : null}
        {currentPage > 2 ? <a className="pagination__link pagination__item pagination__next" onClick={() => handleClick(1)}>{1}</a> : null}
        {currentPage > 3 ? <span className="pagination__item">...</span> : null}
        {currentPage > 1 ? <a className="pagination__link pagination__item" onClick={() => handleClick(currentPage - 1)}>{currentPage - 1}</a> : null}
        <span className="pagination__item pagination__current">{currentPage}</span>
        {currentPage + 1 < pages ? <a className="pagination__link pagination__item pagination__next" onClick={() => handleClick(currentPage + 1)}>{currentPage + 1}</a> : null}
        {currentPage + 2 < pages ? <span className="pagination__item">...</span> : null}
        {currentPage < pages ? <a className="pagination__link pagination__item pagination__next" onClick={() => handleClick(pages)}>{pages}</a> : null}
        {currentPage < pages ? <a className="pagination__link pagination__item pagination__next" onClick={() => handleClick(currentPage + 1)}>&gt;</a> : null}
      </div>
}
